import { render, staticRenderFns } from "./OrderComponent.vue?vue&type=template&id=3d1f0b84"
import script from "./OrderComponent.vue?vue&type=script&lang=ts"
export * from "./OrderComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports